import(/* webpackMode: "eager", webpackExports: ["ReadingProgress"] */ "/tmp/8dedda82af2851e/components/blog/ReadingProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8dedda82af2851e/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContents"] */ "/tmp/8dedda82af2851e/components/blog/TableOfContents.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/blog/PrevNextNav.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/client/link.js");
